import { Box, FormLabel, Stack } from '@mui/material';
import CodeForm from '../verify-code/VerifyCodeForm';
import T from '../text';
import { Field } from 'formik';

export const FormikCodeSelection = ({
  formik,
  name,
  label,
  onCompleted,
  count = 4,
  maxLength = 1,
  width = 64,
  height = 64,
  focus = false,
  disabled,
}) => {
  return (
    <Box>
      <FormLabel>
        <T>{label}</T>
      </FormLabel>
      <Field
        name={name}
        render={({ field, form }) => (
          <Stack flex flexDirection="column" gap={2}>
            <CodeForm
              disabled={disabled}
              value={field.value}
              focus={focus}
              keyPreFix={name}
              count={count}
              maxLength={maxLength}
              width={width}
              height={height}
              onCompleted={onCompleted}
            />
          </Stack>
        )}
      />
    </Box>
  );
};
